/**
 * Wrapper for PropTypes to remove the allowance of null. This fixes the error: `Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'. Type 'null' is not assignable to type 'boolean | undefined'.`
 * @param propType The PropType you wish to use
 * @returns A function with the signuature of a Validator, but does not allow null
 * @example
 * import { optionalPropType } from '@adsk/alloy-react-helpers';
 *
 * type MyComponentProps = {
 *   isDisabled?: boolean;
 * }
 *
 * MyComponent.propTypes = {
 *   isDisabled: optionalPropType(PropTypes.bool)
 * }
 * @see DatePicker Menu PermissionSelect Schedule
 */
export const optionalPropType = propType => function (props, propName) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  return props[propName] === undefined ? null : propType(props, propName, ...rest);
};
//# sourceMappingURL=propTypes.js.map